import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'pi-co2e-info',
    templateUrl: './co2e-info.component.html',
    styleUrls: ['./co2e-info.component.scss'],
    standalone: false
})
export class Co2eInfoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
